import { gql } from '@apollo/client'

export const GET_ACCOUNT = gql`
  query GetAccount {
    account {
      uid email displayName photoUrl planType maxClients
      clientCount runsThisMonth disabledAt createdAt updatedAt
      platforms { platform connected connectedAt email }
      defaultEmailProvider
      modelProvider modelId providerApiKey
      notificationRecipients { id channel label phone chatId verifiedAt addedAt }
    }
  }
`

export const SET_NOTIFICATION_RECIPIENTS = gql`
  mutation SetNotificationRecipients($recipients: [NotificationRecipientInput!]!) {
    setNotificationRecipients(recipients: $recipients) {
      id channel label phone chatId verifiedAt addedAt
    }
  }
`

export const SEND_TEST_NOTIFICATION = gql`
  mutation SendTestNotification($recipientId: ID!) {
    sendTestNotification(recipientId: $recipientId) {
      ok providerId error
    }
  }
`

export const REQUEST_WHATSAPP_VERIFICATION = gql`
  mutation RequestWhatsappVerification($recipientId: ID!) {
    requestWhatsappVerification(recipientId: $recipientId) {
      code waLink phoneNumber expiresIn
    }
  }
`

export const REQUEST_TELEGRAM_CONNECTION = gql`
  mutation RequestTelegramConnection($label: String) {
    requestTelegramConnection(label: $label) {
      code botUrl botUsername expiresIn
    }
  }
`

export const UPDATE_ACCOUNT = gql`
  mutation UpdateAccount(
    $displayName: String
    $photoUrl: String
    $modelProvider: String
    $modelId: String
    $providerApiKey: String
  ) {
    updateAccount(
      displayName: $displayName
      photoUrl: $photoUrl
      modelProvider: $modelProvider
      modelId: $modelId
      providerApiKey: $providerApiKey
    ) {
      uid email displayName photoUrl updatedAt modelProvider modelId providerApiKey
    }
  }
`

export const DELETE_ACCOUNT = gql`
  mutation DeleteAccount {
    deleteAccount
  }
`

export const SET_DEFAULT_EMAIL_PROVIDER = gql`
  mutation SetDefaultEmailProvider($provider: String!) {
    setDefaultEmailProvider(provider: $provider)
  }
`

export const UPDATE_ACCOUNT_PLATFORM = gql`
  mutation UpdateAccountPlatform($platform: String!, $credentials: JSON!) {
    updateAccountPlatform(platform: $platform, credentials: $credentials) {
      platform connected connectedAt
    }
  }
`

export const DISCONNECT_ACCOUNT_PLATFORM = gql`
  mutation DisconnectAccountPlatform($platform: String!) {
    disconnectAccountPlatform(platform: $platform)
  }
`

export const TEST_ACCOUNT_PLATFORM = gql`
  mutation TestAccountPlatform($platform: String!) {
    testAccountPlatform(platform: $platform) {
      platform success error
    }
  }
`

export const STRIPE_CHECKOUT = gql`
  mutation StripeCheckout($planType: String!, $successUrl: String!, $cancelUrl: String!) {
    stripeCheckout(planType: $planType, successUrl: $successUrl, cancelUrl: $cancelUrl) {
      url
    }
  }
`

export const STRIPE_PORTAL = gql`
  mutation StripePortal($returnUrl: String!) {
    stripePortal(returnUrl: $returnUrl) {
      url
    }
  }
`

export const STRIPE_SWITCH_PLAN = gql`
  mutation StripeSwitchPlan($newPlanType: String!) {
    stripeSwitchPlan(newPlanType: $newPlanType) {
      uid planType
    }
  }
`

export const STRIPE_CANCEL = gql`
  mutation StripeCancelSubscription {
    stripeCancelSubscription {
      uid planType
    }
  }
`
